import { FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "../../theme/ThemeProvider";
import { persistAppearanceMode } from "../../theme/persistAppearance";

export default function ThemeToggle() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const nextMode = isDark ? "light" : "dark";
  const label = `Switch to ${nextMode} mode`;
  return (
    <button
      type="button"
      className="topMenuIcon"
      aria-label={label}
      title={label}
      onClick={() => persistAppearanceMode(nextMode)}
    >
      {isDark ? <FiSun aria-hidden="true" /> : <FiMoon aria-hidden="true" />}
    </button>
  );
}
